import React, { useContext, useState } from "react";
import MakroskopLink from "./makroskop-link";
import LoginLink from "./login-link";
import BookmarksLink from "./bookmarks-link";
import SearchButton from "./search-button";
import MenuLink from "./menu-link";
import TextLinks from "./text-links";
import useCmsEdition from "../../hooks/use-cms-edition";
import LoginPopup from "../common/login-popup";
import AnnouncementBanner from "../announcement-banner";
import { useActiveBanner } from "../../hooks/use-active-banner";
import useCmsSpotlight from "../../hooks/use-cms-spotlight";
import { useIsEditionSpotlightMagazine } from "../../hooks/use-is-edition-spotlight-magazine";
import AuthContext from "../../services/firebase/auth-context/provider";
var Header = function Header(_ref) {
    var onOpenSearch = _ref.onOpenSearch, setVisibility = _ref.setVisibility;
    var colorsMap = {
        "is-magazine": "makroYellow",
        "is-spotlight": "makroRedPortuguese",
        "is-edition": "makroBlue"
    };
    var _useState = useState(false), loginPopupStatus = _useState[0], setPopupStatus = _useState[1];
    var authenticated = useContext(AuthContext)[0].authenticated;
    var edition = useCmsEdition().allDatoCmsEdition.edges[0].node;
    var spotlight = useCmsSpotlight();
    var banner = useActiveBanner();
    var loginIconColor = colorsMap[useIsEditionSpotlightMagazine()];
    var paddingBottom = banner ? "" : "pb-6 md:pb-12";
    return /*#__PURE__*/ React.createElement("header", {
        className: "pt-5 bg-white flex flex-wrap relative " + paddingBottom
    }, /*#__PURE__*/ React.createElement("div", {
        className: "contents",
        onClick: function onClick() {
            return setVisibility(false);
        }
    }, /*#__PURE__*/ React.createElement(MakroskopLink, {
        className: "w-1/2 h-32 pr-6 lg:w-1/3"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "w-1/2 lg:w-2/3 flex flex-col"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-xs text-right flex flex-wrap justify-end lg:mb-0"
    }, /*#__PURE__*/ React.createElement(LoginLink, {
        onClick: function onClick() {
            return setPopupStatus(true);
        },
        color: authenticated ? loginIconColor : "makroOrange"
    }), /*#__PURE__*/ React.createElement(BookmarksLink, null), /*#__PURE__*/ React.createElement(SearchButton, {
        openSearch: onOpenSearch,
        style: {
            marginTop: "-5px"
        }
    }), /*#__PURE__*/ React.createElement(MenuLink, {
        edition: edition
    })), /*#__PURE__*/ React.createElement(TextLinks, {
        edition: edition,
        spotlight: spotlight
    })), /*#__PURE__*/ React.createElement(LoginPopup, {
        shouldShowPopup: loginPopupStatus,
        onClose: function onClose() {
            return setPopupStatus(false);
        }
    }), /*#__PURE__*/ React.createElement(AnnouncementBanner, null));
};
export default Header;
